import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";
import { message } from "antd";


export const createProposalStart = (formData) => {
  //console.log(formData)
  return {
    type: actionTypes.CREATE_PROPOSAL_FORM_START,
    storeFormData: formData,
  }
}

export const createProposal = (formData, succMsg) => {
  return {
    type: actionTypes.CREATE_PROPOSAL_FORM_SUCCESS,
    formData: formData,
    succMsg: "Proposal Created Successfully.",
  };
};

export const createProposalFail = (error) => {
  return {
    type: actionTypes.CREATE_PROPOSAL_FORM_FAIL,
    error: error,
  };
};

//////////////////////////////Creating Proposal///////////////////////////////////////
export const createProposalForm = (formData) => {
  return async (dispatch) => {
    dispatch(createProposalStart());
    let result = await axiosRequest.post("user/addProposal", formData, {
      secure: true,
    });
    //console.log("create PROPOSAL_______", result);
    if (result.length > 0) {
      return dispatch(createProposal(result));
    }
  };
};


export const addProposalBIdata = (payload) => {
  //console.log(payload);
  // alert("Alert Action-->")
  return {
    type: actionTypes.ADD_PROPOSAL_BI_FORM_DATA,
    payload: payload,
  };
};

export const proposalID = (_id) => {
  return {
    type: actionTypes.PROPOSAL_ID,
    payload: _id,
  }
}

export const mandatoryDocUpload = (payload) => {
  //console.log(payload);
  return {
    type: actionTypes.MANDATORY_DOCUMENT_UPLOAD,
    payload: payload,
  };
};

export const proposalFormFillingLifeInsurance = (payload) => {
  //console.log(payload);
  return {
    type: actionTypes.PROPOSAL_FORM_FILLING_LIFEINSURANCE,
    payload: payload,
  };
};

export const editProposalFormDataHolder = (storeProposalFormData) => {
  //console.log(storeProposalFormData)
  return {
    type: actionTypes.EDIT_PROPOSAL_FORM_DATA,
    payload: storeProposalFormData,
  }
}

export const editProposalFormDataNum = (storeProposalFormData) => {
  //console.log(storeProposalFormData)
  return {
    type: actionTypes.EDIT_PROPOSAL_FORM_NUMBER,
    payload: storeProposalFormData,
  }
}

export const editProposalFormData = (storeProposalFormData, id) => {
  return async (dispatch) => {
    let result = await axiosRequest.put(`user/updateProposal/${id}`, storeProposalFormData, {
      secure: true,

    });
    console.warn("update Proposal_______", result);

    return dispatch(editProposalFormDataHolder(result));
  };
};

export const updateLeadDynamic = (storeProposalFormData, id) => {
  return async (dispatch) => {
    let result = await axiosRequest.put(`user/updateLeadDynamic/${id}`, storeProposalFormData, {
      secure: true,
    });
    console.warn("updateLeadDynamic_______", result);
    return dispatch(editProposalFormDataNum(result));
  };
};

export const prefillByMobile = (payload) => {
  return async (dispatch) => {
    try {
      let result = await axiosRequest.post("user/dedupe/prefill_by_mobile", payload, {
        secure: true,
      });
      console.warn("prefillByMobile_______", result);

      if (result && !result.errCode && payload.isProposer) {
        message.success(`Mobile to pan data fetched successfully for Proposer`);
      }

      return result;
    } catch (error) {
      console.error("Error in prefillByMobile action:", error);
      throw error;
    }
  };
};

export const storeProposalFormData = (storeProposalFormData) => {
  //console.log(storeProposalFormData);
  alert("Form Stored---->");
  return {
    type: actionTypes.EDIT_PROPOSAL_FORM_DATA,
    payload: storeProposalFormData,
  };
};

//edit the form data
// export const editProposalFormData = (payload) => {
//   //console.log(payload);
//   return {
//     type: actionTypes.EDIT_PROPOSAL_FORM_DATA,
//     payload: payload,
//   };
// };

// export const deleteProposalFormData = () => {
//   return {
//     type: actionTypes.DELETE_PROPOSAL_FORM_DATA,
//   };
// };

// api calling for proposal gagent details.
